import React from "react";
import SearchableSelect from "src/components/custom/SearchableSelect";
import { INPUT_CLASS, LABEL_CLASS, sanitizePhoneDigits } from "src/utils/mcc/studentHelper";

/**
 * Shared fields for MCC Add / Edit trainer modals.
 */
export default function TrainerFormFields({
  form,
  setForm,
  itiOptions,
  tradeOptions,
  showPassword = false,
}) {
  return (
    <div className="space-y-4 overflow-y-auto max-h-[70vh] pr-1">
      <div>
        <label className={LABEL_CLASS}>Name</label>
        <input
          className={INPUT_CLASS}
          value={form.name}
          onChange={(e) =>
            setForm((p) => ({ ...p, name: e.target.value }))
          }
          placeholder="Trainer name"
        />
      </div>
      <div>
        <label className={LABEL_CLASS}>Phone number</label>
        <input
          className={INPUT_CLASS}
          type="text"
          inputMode="numeric"
          autoComplete="tel"
          maxLength={10}
          value={form.phone_number}
          onChange={(e) =>
            setForm((p) => ({
              ...p,
              phone_number: sanitizePhoneDigits(e.target.value),
            }))
          }
          placeholder="10 digits only"
        />
      </div>
      {showPassword && (
        <div>
          <label className={LABEL_CLASS}>Password</label>
          <input
            className={INPUT_CLASS}
            type="text"
            autoComplete="new-password"
            value={form.password ?? ""}
            onChange={(e) =>
              setForm((p) => ({ ...p, password: e.target.value }))
            }
            placeholder="Trainer login password"
          />
        </div>
      )}
      <SearchableSelect
        label="ITI"
        placeholder="Select ITI"
        options={itiOptions}
        value={form.iti_id}
        onChange={(v) =>
          setForm((p) => ({ ...p, iti_id: v, trade_id: "" }))
        }
      />
      <SearchableSelect
        label="Trade"
        placeholder={form.iti_id ? "Select trade" : "Select ITI first"}
        options={tradeOptions}
        value={form.trade_id}
        onChange={(v) =>
          setForm((p) => ({ ...p, trade_id: v }))
        }
      />
    </div>
  );
}
